import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import ReactPaginate from "react-paginate";
// import "./Paginating.css"; // Ensure styles are imported if necessary
import { getPaginatedMembers, deleteMember } from "../../../api/apiServices";
import { Link } from "react-router-dom";
import Loader from "../../Common/Spinner/Loader";
import toast from "react-hot-toast";
const titles = ["MR.", "MR", "MRS.", "MISS"];

export const PaginatedMembers = () => {
	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	let [isLoading, setIsLoading] = useState(true);

	const [currentPage, setCurrentPage] = useState(1);
	const membersPerPage = 20;

	const {
		data: members,
		isError,
		error,
	} = useQuery(
		["members", currentPage],
		() => getPaginatedMembers(currentPage),
		{
			onSuccess: async () => {
				setIsLoading(false);
			},
			onError: async (err) => {
				toast.error(err.message, {
					duration: 5000,
					className: "toast-message",
				});
				setIsLoading(true);
				return false;
			},
		},
		{
			keepPreviousData: true,
			refetchOnMount: false,
			refetchOnWindowFocus: false,
		}
	);

	console.log(members);

	const pageCount = Math.ceil(members?.total_records / membersPerPage);
	//   const pageCount = Math.ceil(data.totalPosts / postsPerPage);

	// Handle page click
	const handlePageClick = (event) => {
		setCurrentPage(event.selected + 1); // Fix: Add 1 to convert from 0-based index to 1-based
	};

	let content;
	if (isLoading) {
		content = (
			<div className="loader">
				<p>Loading Membership Data...</p>
				<Loader />
			</div>
		);
	} else if (isError) {
		content = <p>{error.message}</p>;
	} else {
		content = (
			<div className="table-responsive lg table-wrapper">
				<table className="table table-bordered table-hover table-striped">
					<thead className="align">
						<tr>
							<th scope="col">#</th>
							<th scope="col">PF Number</th>
							<th scope="col">Full Name</th>
							<th scope="col">Region</th>
							<th scope="col">Mobile Number</th>
							<th scope="col">Email</th>
							<th scope="col">Action</th>
						</tr>
					</thead>
					<tbody>
						{members?.data?.data?.map((mem, index) => (
							<tr key={index}>
								<td>
									{membersPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td>{mem.pf_number}</td>
								{titles.includes(mem.title) ? (
									<td style={{ whiteSpace: "nowrap" }}>
										{mem.first_name.toUpperCase()}&nbsp;
										{mem.middle_name.toUpperCase()}&nbsp;
										{mem.last_name.toUpperCase()}
									</td>
								) : (
									<td style={{ whiteSpace: "nowrap" }}>
										{mem.title.toUpperCase()}&nbsp;
										{mem.first_name.toUpperCase()}&nbsp;
										{mem.middle_name.toUpperCase()}&nbsp;
										{mem.last_name.toUpperCase()}
									</td>
								)}
								<td style={{ whiteSpace: "nowrap" }}>
									{mem.region}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{mem.mobile_number}
								</td>
								<td>{mem.email}</td>
								<td style={{ whiteSpace: "nowrap" }}>
									<div style={{ display: "inline-block" }}>
										<Link
											to={`/view_member/${mem.id}`}
											className="small mr-3"
										>
											{" "}
											<i className="fa fa-eye"></i> view
										</Link>
									</div>
									&nbsp; &nbsp;
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	return (
		<>
			<section className="content-header">
				<h1>Paginated Global Members</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title"></h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{content}</div>
							{!isLoading && (
								<div className="panel-footer">
									<ReactPaginate
										previousLabel={"Previous"}
										nextLabel={"Next"}
										breakLabel={"..."}
										breakClassName={"break-me"}
										pageCount={pageCount}
										marginPagesDisplayed={2} // How many pages to show at the beginning and end
										pageRangeDisplayed={3} // How many pages to show around the current page
										onPageChange={handlePageClick}
										containerClassName={"pagination"}
										activeClassName={"active"}
									/>
								</div>
							)}
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
